"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./WebsiteTerms.css");

var _react = _interopRequireDefault(require("react"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var WebsiteTerms = /*#__PURE__*/function (_React$Component) {
  _inherits(WebsiteTerms, _React$Component);

  var _super = _createSuper(WebsiteTerms);

  function WebsiteTerms() {
    _classCallCheck(this, WebsiteTerms);

    return _super.apply(this, arguments);
  }

  _createClass(WebsiteTerms, [{
    key: "_renderHeaderBody",
    value:
    /* GR-10181 TODO clean once transition is complete */
    function _renderHeaderBody(section, isBodyV2) {
      if (isBodyV2) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: section
        }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
          tag: "h4",
          contentKey: "".concat(section, "-Header")
        }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
          tag: "p",
          contentKey: "".concat(section, "-Body_v2")
        }));
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: section
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h4",
        contentKey: "".concat(section, "-Header")
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "".concat(section, "-Body")
      }));
    }
  }, {
    key: "_renderExtraBody",
    value: function _renderExtraBody(contentKey) {
      return /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: contentKey
      });
    }
  }, {
    key: "_renderRules",
    value: function _renderRules() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("rules", true), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody4"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody5"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody6"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody7"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "ruleBody8"
      })));
    }
  }, {
    key: "_renderDefinitions",
    value: function _renderDefinitions() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "definitions"
      }), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm4"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm5"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm6"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm7"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm8"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm9"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm10"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm11"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm12"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm13"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm14"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm15"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm16"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm17"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm18"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm19"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm20"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm21"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm22"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "definitionsTerm23"
      })));
    }
  }, {
    key: "_renderEligiblityAndEnrollment",
    value: function _renderEligiblityAndEnrollment() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("eligibilityAndEnrollment", false), this._renderExtraBody("eligibilityAndEnrollmentBody1"));
    }
  }, {
    key: "_renderSlpPlanParticipants",
    value: function _renderSlpPlanParticipants() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("slpPlanParticipants", false), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule4"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule5"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpPlanRule6"
      })), this._renderExtraBody("slpPlanParticipantsBody1"), this._renderExtraBody("slpPlanParticipantsBody2"), this._renderExtraBody("slpPlanParticipantsBody3"), this._renderExtraBody("slpPlanParticipantsBody4"), this._renderExtraBody("slpPlanParticipantsBody5"), this._renderExtraBody("slpPlanParticipantsBody7"));
    }
  }, {
    key: "_renderCsuPlanParticipants",
    value: function _renderCsuPlanParticipants() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("csuPlanParticipants", false), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule4"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule5"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "csuPlanRule6"
      })), this._renderExtraBody("csuPlanParticipantsBody1"), this._renderExtraBody("csuPlanParticipantsBody2"), this._renderExtraBody("csuPlanParticipantsBody3"), this._renderExtraBody("csuPlanParticipantsBody4"), this._renderExtraBody("csuPlanParticipantsBody5"), this._renderExtraBody("csuPlanParticipantsBody6"), this._renderExtraBody("csuPlanParticipantsBody8"));
    }
  }, {
    key: "_renderStudentLoanRefinancing",
    value: function _renderStudentLoanRefinancing() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("studentLoanRefinancing", false), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule4"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule5"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "studentLoanRefinancingRule6"
      })), this._renderExtraBody("studentLoanRefinancingBody1"));
    }
  }, {
    key: "_renderRewardProgram",
    value: function _renderRewardProgram() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("rewardProgram", false), this._renderExtraBody("rewardProgramBody1"), this._renderExtraBody("rewardProgramBody2"), this._renderExtraBody("rewardProgramBody3"), this._renderExtraBody("rewardProgramBody4"), this._renderExtraBody("rewardProgramBody5"), this._renderExtraBody("rewardProgramBody6"), this._renderExtraBody("rewardProgramBody7"), this._renderExtraBody("rewardProgramBody8"), this._renderExtraBody("rewardProgramBody9"), this._renderExtraBody("rewardProgramBody10"), this._renderExtraBody("rewardProgramBody11"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closeAccountRule1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closeAccountRule2"
      })), this._renderExtraBody("rewardProgramBody12"), this._renderExtraBody("rewardProgramBody13"), this._renderExtraBody("rewardProgramBody14"));
    }
  }, {
    key: "_renderPaymentProcessing",
    value: function _renderPaymentProcessing() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("paymentProcessing", false), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpBenefits1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpBenefits2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpBenefits3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "slpBenefits4"
      })), this._renderExtraBody("csuBenefits"), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "csuBenefits1"
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "csuBenefits2"
      })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        contentKey: "csuBenefits3"
      }))));
    }
  }, {
    key: "_renderClosureOfAccount",
    value: function _renderClosureOfAccount() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h4",
        contentKey: "closureOfAccount-Header"
      }), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountInfo1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountInfo2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountInfo3"
      }), /*#__PURE__*/_react.default.createElement("ol", {
        type: "a"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountAdditionalInfo1"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountAdditionalInfo2"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountAdditionalInfo3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "li",
        contentKey: "closureOfAccountAdditionalInfo4"
      }))));
    }
  }, {
    key: "_renderNoAdvice",
    value: function _renderNoAdvice() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("noAdvice", false), this._renderExtraBody("noAdviceBody1"));
    }
  }, {
    key: "_renderDisclaimerSection",
    value: function _renderDisclaimerSection() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("disclaimer", true));
    }
  }, {
    key: "_renderMiscellaneous",
    value: function _renderMiscellaneous() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._renderHeaderBody("miscellaneous", false), this._renderExtraBody("miscellaneousBody1"), this._renderExtraBody("miscellaneousBody2"), this._renderExtraBody("miscellaneousBody3"), this._renderExtraBody("miscellaneousBody4"), this._renderExtraBody("miscellaneousBody5"), this._renderExtraBody("miscellaneousBody6"));
    }
  }, {
    key: "_renderIntro",
    value: function _renderIntro() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h4",
        contentKey: "intro-Header_v3"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "intro-Body_v3"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, null, /*#__PURE__*/_react.default.createElement("section", {
        className: "top-banner"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "banner-content"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h1",
        contentKey: "websiteTermsHeader_v2"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "static-content-container"
      }, /*#__PURE__*/_react.default.createElement("section", {
        className: "static-content"
      }, this._renderIntro(), /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, this._renderDefinitions()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderEligiblityAndEnrollment()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderSlpPlanParticipants()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderCsuPlanParticipants()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderStudentLoanRefinancing()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderRewardProgram()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderPaymentProcessing()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderClosureOfAccount()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderNoAdvice()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderDisclaimerSection()), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderHeaderBody("effectiveDateAndTerm", false)), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderHeaderBody("choiceOfLaw", false)), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderHeaderBody("collectionAndUseOfInfo", false)), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("li", null, this._renderMiscellaneous())))));
    }
  }]);

  return WebsiteTerms;
}(_react.default.Component);
/* GR-10181 TODO clean once transition is complete */


var propulatedView = (0, _Propulator.default)(WebsiteTerms, {
  sessionStore: ["session"]
});

var _default = (0, _MobxView.default)(propulatedView);

exports.default = _default;